import React from 'react';
import { ReactComponent as OrnamenIcon } from "../../assets/ornament/ornament2.svg";
import { ReactComponent as Logodark } from "../../assets/logo_dark.svg";


const ModalBox = ({ active, children, onClose, className }) => {
    return (
        active &&
        <div
            className={`fixed flex flex-col items-center justify-center top-0 left-0 right-0 bottom-0 bg-[#21212195] backdrop-blur-sm z-10 ${className}`}>
            <div className="flex flex-col relative bg-gradient-to-l from-[#FFB6FFBF] to-[#B9BDFFBF] sm:rounded-lg  sm:max-w-xl w-full max-h-full overflow-x-auto z-10">
                <div className="m-3 items-center flex flex-col  z-1">
                    <Logodark className=" h-12 w-52" />
                </div>
                <div className="absolute top-0 right-0 left-0 flex flex-row justify-end items-end">
                    <OrnamenIcon className="flex  sm:w-[500px] sm:h-[70px] h-[30px] w-[200px]" />
                </div>
                <div className='absolute top-3 right-3 h-10 w-10 z-2 text-lightColor '>
                    <div onClick={onClose} className='h-full aspect-square bg-lightColor flex items-center justify-center rounded-full cursor-pointer'>X</div>
                </div>
                <div className="flex flex-col p-4 ">
                    {children}
                </div>
            </div>
            <div className='absolute top-2 right-2 left-2 bottom-2 cursor-pointer' onClick={onClose}>
            </div>
        </div>
    );
};

export default ModalBox;
